import React from "react";

import Dashboard from "../../components/Dashboard/Home";
export default function Home() {
  
  return (
    <Dashboard />
  );
}
